/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */

import { hasAsOfDate } from './Accounts';

// Account/Product Type Filter Options
export const ALL_LABEL = 'All';
export const RETIREMENT_LABEL = 'Retirement';
export const NON_RETIREMENT_LABEL = 'Non-Retirement';
export const RAS_LABEL = 'Retirement Advisory Service';
export const APP_LABEL = 'ActivePlus Portfolios';
export const MUTUAL_FUND_LABEL = 'Mutual Fund';
export const BROKERAGE_LABEL = 'Brokerage';
export const COLLEGE_SAVINGS_LABEL = '529 College Savings Plans';
export const AK_ONLY_COLLEGE_SAVINGS_LABEL = '529 Plans';
export const OWNED_LABEL = 'Owned';
export const VIEW_ONLY_LABEL = 'View Only';
export const CUSTOM_LABEL = 'Custom';
export const RELATED_LABEL = 'Related';

// Time Period Filter Options
export const LAST_3_MONTHS = 'last3Months';
export const LAST_6_MONTHS = 'last6Months';
export const LAST_12_MONTHS = 'last12Months';
export const YEAR_TO_DATE = 'yearToDate';
export const PRIOR_YEAR = 'priorYear';
export const SINCE_INCEPTION = 'sinceInception';

export const timePeriodLabelMap = {
  [LAST_3_MONTHS]: 'Last 3 Months',
  [LAST_6_MONTHS]: 'Last 6 Months',
  [LAST_12_MONTHS]: 'Last 12 Months',
  [YEAR_TO_DATE]: 'Year to Date',
  [PRIOR_YEAR]: 'Prior Calendar Year',
  [SINCE_INCEPTION]: 'Since Inception'
};

export const AccountTypeOptions = [
  {
    label: ALL_LABEL,
    value: 'All'
  },
  {
    label: RAS_LABEL,
    value: 'Retirement Advisory Service'
  },
  {
    label: APP_LABEL,
    value: 'ActivePlus Portfolios'
  },
  {
    label: MUTUAL_FUND_LABEL,
    value: 'Mutual Fund'
  },
  {
    label: BROKERAGE_LABEL,
    value: 'Brokerage'
  },
  {
    label: COLLEGE_SAVINGS_LABEL,
    value: '529 College Savings Plans'
  },
  {
    label: RETIREMENT_LABEL,
    value: 'Retirement'
  },
  {
    label: NON_RETIREMENT_LABEL,
    value: 'Non-Retirement'
  },
  {
    label: OWNED_LABEL,
    value: 'Owned'
  },
  {
    label: RELATED_LABEL,
    value: 'Related'
  },
  {
    label: VIEW_ONLY_LABEL,
    value: 'View Only'
  }
];
export const AccountTypeOptionsMap = AccountTypeOptions.reduce(
  (reducer, current, idx) => ({
    ...reducer,
    [current.label]: {
      id: idx + 1,
      ...current
    }
  }),
  {}
);

export const getAccountTypeForLabel = (label) => AccountTypeOptionsMap[label];

const initialPeriod = LAST_3_MONTHS;

export const initialDateRangeFilter = {
  period: initialPeriod,
  custom: false,
  fromDate: null,
  toDate: null
};

export const initialSinceInceptionDateRangeFilter = {
  ...initialDateRangeFilter,
  period: SINCE_INCEPTION
};

export const initialFilter = {
  filter: getAccountTypeForLabel(ALL_LABEL),
  dateRangeFilter: initialDateRangeFilter
};

export const initialActivitySummaryFilter = initialFilter;
export const initialPortfolioGrowthFilter = initialFilter;
export const initialRateOfReturnFilter = {
  ...initialFilter,
  dateRangeFilter: initialSinceInceptionDateRangeFilter
};

export const updateAccountFilterOptions = (
  includedAccountOptions,
) => {
  return includedAccountOptions;
};

export const filterAccountsWithAsOfDate = (accounts) => {
  if (accounts && accounts.length) {
    return accounts.filter(hasAsOfDate);
  }
  return [];
};
